import moment from 'moment'
const notificationSound = new Audio('https://enterprise-s3.zwiz.app/sound/noti_sound.m4a')
export function notificationNewChatMessage({ users, timeInterval }) {
  const startTime = moment().subtract(timeInterval, 'ms')
  const currentTime = moment()
  const isAllowNotification = grantedNotification()
  if (isAllowNotification && !JSON.parse(localStorage.getItem('muteChat'))) {
    let newChatMessages = users.filter((user) => {
      const isNew = moment(user.lastreply_time).isBetween(startTime, currentTime)
      return isNew ? user : null
    })
    if (newChatMessages.length > 0) {
      newChatMessages = newChatMessages.slice(0, 4)
      newChatMessages.forEach((message) => {
        const options = {
          body: `${message.first_name}: ${message.lastmessage}`,
          icon: '/static/img/logo-small-mobile.png'
        }
        new Notification('ZWIZ.AI Chatbot', options)
      })

      notificationSound.play()
    }
  }
}

export function notificationNewTicket({ tickets, timeInterval }) {
  const startTime = moment().subtract(timeInterval, 'ms')
  const currentTime = moment()
  const isAllowNotification = grantedNotification()
  if (isAllowNotification && !JSON.parse(localStorage.getItem('muteChat'))) {
    let newTickets = tickets.filter((ticket) => {
      const isNew = moment(ticket.starttime).isBetween(startTime, currentTime)
      return isNew && ticket.status === 'pending' ? ticket : null
    })

    if (newTickets && newTickets.length > 0) {
      newTickets = newTickets.slice(0, 4)
      newTickets.forEach((message) => {
        const options = {
          body: `${message.first_name}: ${message.details}`,
          icon: '/static/img/logo-small-mobile.png'
        }
        new Notification('ZWIZ.AI Chatbot', options)
      })
      notificationSound.play()
    }
  }
}

export async function grantedNotification() {
  let granted = false

  if (Notification.permission === 'granted') {
    granted = true
  } else if (Notification.permission !== 'denied') {
    let permission = await Notification.requestPermission()
    granted = permission === 'granted' ? true : false
  }
  return granted
}



// WEBPACK FOOTER //
// ./src/utils/notification.js